import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import "../scss/index.scss";
import { adminAutoLoginUser } from "../store/actions/user.actions";
import DataLoader2 from "../components/globalView/DataLoader2";

const AdminLogin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const startedRef = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    // Run the impersonation exactly once even under StrictMode double-invoke.
    if (startedRef.current) return;
    startedRef.current = true;

    const ssid = new URLSearchParams(location.search).get("ssid");
    if (!ssid || !ssid.trim()) {
      setError("Missing impersonation token (ssid).");
      return;
    }

    dispatch(adminAutoLoginUser(ssid.trim()))
      .then(() => {
        navigate("/", { replace: true });
      })
      .catch((err) => {
        setError(err?.message || "This impersonation link is invalid or has expired.");
      });
  }, [dispatch, location.search, navigate]);

  if (error) {
    return (
      <>
        <Helmet>
          <title>Admin Login | Instaswap Partners</title>
        </Helmet>
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 20,
            background: "#0a0b0b",
          }}
        >
          <div
            className="iswModal"
            style={{
              maxWidth: 440,
              textAlign: "center",
            }}
          >
            <h1 className="mTitle">Impersonation failed</h1>
            <p className="mSub">{error}</p>
            <button
              className="btnPrimary block"
              onClick={() => navigate("/login", { replace: true })}
              type="button"
            >
              Go to login
            </button>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Helmet>
        <title>Admin Login | Instaswap Partners</title>
      </Helmet>
      <DataLoader2 />
    </>
  );
};

export default AdminLogin;
